/**
 * Third party libraries
 */

import PhotoSwipeMounter from './vendor/jquery.photoswipe';

window.$      = window.jQuery = require('jquery');
window.Swiper = require('swiper');

PhotoSwipeMounter(jQuery);